<template lang="html">
  <div>
    <giftcard-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleSidebar"
      :data="sidebarData"
    />
    <form-wizard
    :start-index="4"
    color="#fff"
      errorColor="rgba(var(--vs-danger), 1)"
      :title="null"
      :subtitle="null"
      finishButtonText="Submit"
      @on-complete="formSubmitted"
    >
      <template slot="footer" slot-scope="props">
        <!-- <div class="wizard-footer-left">
           <wizard-button v-if="props.activeTabIndex > 0 && !props.isLastStep" @click.native="props.prevTab()" :style="props.fillButtonStyle">Previous</wizard-button>
        </div>
        <div class="wizard-footer-right">
          <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle">Nexttt</wizard-button> -->

        <div class="wizard-footer-right">
          <wizard-button
            v-if="props.activeTabIndex == 4"
            class="wizard-footer-right finish-button"
            @click.native="formSubmitted"
            :style="props.fillButtonStyle"
            >{{ "Submit" }}</wizard-button
          >
        </div>
        <!-- </div> -->
      </template>
      <!--  <template slot="step" scope="props">
        <wizard-step
          :tab="props.tab"
          :transition="props.transition"
          :key="props.tab.title"
          :index="props.index"
          :color="'#fff' "
        >
        </wizard-step>
      </template> -->
      <wizard-step
        slot-scope="props"
        slot="step"
        :tab="{
          color: props.index == 0 ? '#fff' : '#ccc',
          title: props.tab.title,
          checked: props.index == 0 ? false : true,
          checked: false,
          active: props.index == 0 ? true : false
        }"
        :transition="props.transition"
        :key="props.tab.title"
        :index="props.index"
      >
      </wizard-step>

      <!-- <tab-content title="Register" class="mb-5" :before-change="validateStep1"> -->
      <tab-content title="Register" class="mb-5"> </tab-content>
      <tab-content title="Email Notification (Submission)" class="mb-5">
      </tab-content>
      <tab-content title="Approval Process" class="mb-5"> </tab-content>
      <tab-content title="Email Notification (Successful Sign up)" class="mb-5">
      </tab-content>
      <tab-content title=" Go Live" class="mb-5">
        <!-- tab 1 content -->
        <!-- <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mt-5">
            <vs-input label="First Name" v-model="firstName" class="w-full" />
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5">
            <vs-input label="Last Name" v-model="lastName" class="w-full" />
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5">
            <vs-input
              type="email"
              label="Email"
              v-model="email"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5">
            <vs-select v-model="city" class="w-full select-large" label="City">
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in cityOptions"
                class="w-full"
              />
            </vs-select>
          </div>
        </div> -->
        <vx-card>
          <!-- <div slot="no-body" class="full-page-bg-color">
            <div class="vx-row no-gutter items-center"> -->
          <!-- <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg"> -->
          <!-- <div class="vx-col sm:w-full md:w-full d-theme-dark-bg">
                <div class="p-8 login-tabs-container"> -->
          <div class="vx-card__title mb-4">
            <h4 class="mb-4 text-primary">Merchant Registration</h4>
          </div>

          <div>
            <form data-vv-scope="step-1" >
              <div class="vx-row">
                <div class="vx-col md:w-1/2">
                  <div class="flex items-end">
                    <vs-input
                      type="text"
                      name="companyName"
                      icon-no-border
                      label="Company Name"
                      v-model="companyName"
                      v-validate="'required'"
                      class="w-full mt-6"
                    />

                    <span class="required mb-10">*</span>
                  </div>
                  <span
                    class="text-danger"
                    v-show="errors.has('step-1.companyName')"
                    >{{ errors.first("step-1.companyName") }}</span
                  >
                </div>
                <div class="vx-col md:w-1/2">
                  <div class="flex items-end">
                    <vs-input
                      type="text"
                      name="companyROCNo"
                      icon-no-border
                      label="Company ROC No."
                      v-model="companyROCNo"
                      v-validate="'required'"
                      class="w-full mt-6"
                    />

                    <span class="required mb-10">*</span>
                  </div>
                  <span
                    class="text-danger"
                    v-show="errors.has('step-1.companyROCNo')"
                    >{{ errors.first("step-1.companyROCNo") }}</span
                  >
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                  <div class="flex items-end">
                    <vs-input
                      type="text"
                      name="brandName"
                      label="Brand Name"
                      v-model="brandName"
                      class="w-full mt-6"
                      v-validate="'required'"
                    />

                    <span class="required mb-10">*</span>
                    <br />
                  </div>
                  <span
                    class="text-danger"
                    v-show="errors.has('step-1.brandName')"
                    >{{ errors.first("step-1.brandName") }}</span
                  >
                </div>
              </div>
              <div class="vx-row mt-4">
                <div class="vx-col w-full ">
                  <label for="brandDesc">Brand Description</label>
                  <vs-textarea
                    type="text"
                    name="brandDesc"
                    v-model="brandDesc"
                    class="w-full"
                    height="130px"
                    width="200px"
                  />
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full ">
                  <vs-input
                    type="text"
                    name="ownerName"
                    label="Owner Name"
                    v-model="ownerName"
                    class="w-full mt-6"
                  />

                  <br />
                  <span
                    class="text-danger"
                    v-show="errors.has('step-1.ownerName')"
                    >{{ errors.first("step-1.ownerName") }}</span
                  >
                </div>
                <div class="vx-col md:w-1/2 w-full ">
                  <vs-input
                    type="text"
                    name="ownerContactNo"
                    label="Owner Contact No"
                    placeholder="e.g. 012-34567890"
                    v-model="ownerContactNo"
                    v-validate="{
                      regex: /^(\+?6?01)[0-46-9]-*[0-9]{7,8}$/
                    }"
                    class="w-full mt-6"
                  />

                  <br />
                  <span
                    class="text-danger"
                    v-show="errors.has('step-1.ownerContactNo')"
                    >{{ errors.first("step-1.ownerContactNo") }}</span
                  >
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col md:w-1/4 w-full 10">
                  <div class="flex items-end">
                    <vs-input
                      type="text"
                      name="picName"
                      label="PIC Name"
                      v-model="picName"
                      class="w-full mt-6"
                      v-validate="'required'"
                    />

                    <span class="required mb-10">*</span>
                  </div>
                  <span
                    class="text-danger"
                    v-show="errors.has('step-1.picName')"
                    >{{ errors.first("step-1.picName") }}</span
                  >
                </div>
                <div class="vx-col md:w-1/4 w-full ">
                  <vs-input
                    type="text"
                    name="picDesignation"
                    label="PIC Designation"
                    placeholder="e.g. 'MANAGER'"
                    v-model="picDesignation"
                    class="w-full mt-6"
                  />

                  <br />
                  <span
                    class="text-danger"
                    v-show="errors.has('step-1.picDesignation')"
                    >{{ errors.first("step-1.picDesignation") }}</span
                  >
                </div>
                <div class="vx-col md:w-1/4 w-full">
                  <div class="flex items-end">
                    <vs-input
                      type="text"
                      name="picContactNo"
                      label="PIC Contact No"
                      v-model="picContactNo"
                      class="w-full mt-6"
                      v-validate="{
                        required: true,
                        regex: /^(\+?6?01)[0-46-9]-*[0-9]{7,8}$/
                      }"
                    />

                    <span class="required mb-10">*</span>
                  </div>
                  <span
                    class="text-danger"
                    v-show="errors.has('step-1.picContactNo')"
                    >{{ errors.first("step-1.picContactNo") }}</span
                  >
                </div>
              </div>

              <div class="vx-row">
                <div class="vx-col md:w-1/4 w-full">
                  <div class="flex items-end">
                    <vs-input
                      type="text"
                      name="picEmail"
                      label="PIC Email"
                      v-model="picEmail"
                      class="w-full mt-6"
                      v-validate="'required|email'"
                      @change="checkCustomConfirm()"
                    />

                    <span class="required mb-10">*</span>
                  </div>
                  <span
                    class="text-danger"
                    v-show="errors.has('step-1.picEmail')"
                    >{{ errors.first("step-1.picEmail") }}</span
                  >
                </div>
                <div class="vx-col md:w-1/4 w-full">
                  <div class="flex items-end">
                    <vs-input
                      type="text"
                      name="picEmailConfirm"
                      label="Confirm PIC Email"
                      v-model="picEmailConfirm"
                      @change="checkCustomConfirm()"
                      v-validate="'required|custom_validation2'"
                      class="w-full mt-6"
                    />
                    <span class="required mb-10">*</span>
                  </div>
                  <span
                    class="text-danger"
                    v-show="errors.has('step-1.picEmailConfirm')"
                    >{{ errors.first("step-1.picEmailConfirm") }}</span
                  >
                </div>
              </div>

              <div class="vx-row">
                <div class="vx-col md:w-1/4 w-full ">
                  <!-- <vs-input
                  type="text"
                  name="bankName"
                  label="Bank Name*"
                  v-model="bankName"
                  class="w-full mt-6"
                  v-validate="'required'"
                /> -->
                  <!-- <div class="vx-col md:w-1/4 w-full con-select-example"> -->
                  <div class="vs-component vs-con-input-label vs-input w-full mt-6 vs-input-primary">
                  <label for="" class="vs-input--label" >Bank Name </label>
                  <div class="flex items-end">
                    <v-select v-model="bankName"  class="mt-0 w-full" :options="banks" name="bankName" />
                  </div>
                  <span
                    class="text-danger"
                    v-show="errors.has('step-1.bankName')"
                    >{{ errors.first("step-1.bankName") }}</span
                  >
                </div>


                  

                  
                </div>
                <div class="vx-col md:w-1/4 w-full ">
                  <vs-input
                    type="text"
                    name="accountName"
                    label="Account Name"
                    v-model="accountName"
                    class="w-full mt-6"
                  />

                  <br />
                  <span
                    class="text-danger"
                    v-show="errors.has('step-1.accountName')"
                    >{{ errors.first("step-1.accountName") }}</span
                  >
                </div>
                <div class="vx-col md:w-1/4 w-full ">
                  <vs-input
                    type="text"
                    name="accountNo"
                    label="Account No."
                    v-model="accountNo"
                    class="w-full mt-6"
                  />

                  <br />
                  <span
                    class="text-danger"
                    v-show="errors.has('step-1.accountNo')"
                    >{{ errors.first("step-1.accountNo") }}</span
                  >
                </div>
              </div>

              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full ">
                  <div class="flex items-end">
                    <vs-input
                      type="text"
                      name="address1"
                      label="Address 1"
                      v-model="address1"
                      class="w-full mt-6"
                      v-validate="'required'"
                    />

                    <span class="required mb-10">*</span>
                  </div>
                  <span
                    class="text-danger"
                    v-show="errors.has('step-1.address1')"
                    >{{ errors.first("step-1.address1") }}</span
                  >
                </div>
                <div class="vx-col md:w-1/2 w-full ">
                  <vs-input
                    type="text"
                    name="address2"
                    label="Address 2"
                    v-model="address2"
                    class="w-full mt-6"
                  />
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                  <vs-input
                    type="text"
                    name="address3"
                    label="Address 3"
                    v-model="address3"
                    class="w-full mt-6"
                  />
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <vs-input
                    type="text"
                    name="address4"
                    label="Address 4"
                    v-model="address4"
                    class="w-full mt-6"
                  />
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col md:w-1/4 w-full">
                  <div class="flex items-end">
                    <vs-input
                      type="text"
                      name="postcode"
                      label="Postcode"
                      placeholder="e.g. 12345"
                      v-model="postcode"
                      class="w-full mt-6"
                      v-validate="{ required: true, regex: /^[0-9]{5}$/ }"
                    />

                    <span class="required mb-10">*</span>
                  </div>
                  <span
                    class="text-danger"
                    v-show="errors.has('step-1.postcode')"
                    >{{ errors.first("step-1.postcode") }}</span
                  >
                </div>
                <div class="vx-col md:w-1/4 w-full">
                  <div class="vs-component vs-con-input-label vs-input w-full mt-6 vs-input-primary">
                  <label for="" class="vs-input--label" >State </label>
                    <span class="required ">*</span>
                  <div class="flex items-end">
                    <v-select v-model="state"  class="mt-0 w-full" :options="states" v-validate="'required'" name="state" />
                  </div>
                  <span
                    class="text-danger"
                    v-show="errors.has('step-1.state')"
                    >{{ errors.first("step-1.state") }}</span
                  >
                </div>

                </div>

                <div class="vx-col md:w-1/2 w-full">
                    <div class="vs-component vs-con-input-label vs-input w-full mt-6 vs-input-primary">
                  <label for="" class="vs-input--label" >Salesperson ID </label>
                    <span class="required "><small>*Please fill in Salesperson ID if you have this information</small></span>
                  <div class="flex items-end">
                    <vs-input
                      type="text"
                      v-model="mcSalesManUid"
                      class="w-full"
                    />
                  </div>
                  <span
                    class="text-danger"
                    v-show="errors.has('step-1.state')"
                    >{{ errors.first("step-1.state") }}</span
                  >
              </div>
                </div>


              </div>
              <div class="vx-row">
                <div class="flex items-end">
                  <div class=" w-full md:mt-6 ml-4">
                    <p>Choose onboarding package:</p>
                  </div>
                  <span class="required mb-0">*</span>
                </div>
              </div>
              <div class="vx-row">
                <div class=" w-full ml-4">
                  <!-- <div class="demo-alignment"> -->
                  <div class="centerx">
                    <vs-col v-for="(merchantPackage, index) in packages" :key="index">
                      <vs-checkbox v-validate="'custom_validation1'" v-model="merchantPackage.isSelected" :vs-value="merchantPackage" name="acceptPackages"
                        >{{ merchantPackage.name }}</vs-checkbox
                      >
                    </vs-col>
                  </div>
                  <span
                  class="text-danger"
                  v-show="errors.has('step-1.acceptPackages')"
                  >{{ errors.first("step-1.acceptPackages") }}</span
                >
                </div>
              </div>
              <!-- <div class="vx-col md:w-1/2 w-full md:mt-6">
                  <div class="demo-alignment">
                    <div class="flex">
                      <vs-checkbox v-model="sellGiftcard"
                        >Package II - Online Store for Restaurant (Your own
                        store)</vs-checkbox
                      >
                    </div>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mt-6">
                  <div class="demo-alignment">
                    <div class="flex">
                      <vs-checkbox v-model="sellFood"
                        >Package III - Invited Marketplace (for e-Gift Cards and
                        e-Vouchers)</vs-checkbox
                      >
                    </div>
                  </div>
                </div>
              </div> -->
              <!-- <div class="vx-row"> -->
              <!-- <div class="vx-col md:w-1/4 w-full"> -->
              <div class="flex flex-wrap justify-start mt-5">
                <vs-checkbox
                  @change="checkTnc()"
                  name="acceptTnc"
                  v-model="acceptTnc"
                  class="mb-3"
                  v-validate="'custom_validation'"
                  >I have read all the
                </vs-checkbox>
                <a
                  href="https://worldpos.worldgroup.asia/terms-and-conditions/"
                  target="_blank"
                  >terms & conditions
                </a>
                <p>
                  &nbsp;contained therein and I am agreeable to the same and also the charges applied under the Package(s)
                </p>
              </div>
              <span
                class="text-danger"
                v-show="errors.has('step-1.acceptTnc')"
                >{{ errors.first("step-1.acceptTnc") }}</span
              >
              <!-- </div> -->
              <!-- </div> -->

              <div class="vx-col md:w-1/2 w-full md:mt-6"></div>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full ">
                  <!-- <vs-input
                            type="text"
                            name="ownerName"
                            label-placeholder="Address 2"
                            v-model="ownerName"
                            class="w-full mt-6"
                          /> -->
                </div>
              </div>
              <!-- <div class="flex flex-wrap justify-between my-5">
                      <vs-checkbox v-model="checkbox_remember_me" class="mb-3"
                        >Remember Me</vs-checkbox
                      >
                      <router-link to>Forgot Password?</router-link>
                    </div>
                    <vs-button class="centerx" :disabled="!validateForm"
                      >Login</vs-button
                    > -->
            </form>
          </div>
          <!-- </div>
              </div>
            </div>
          </div> -->
        </vx-card>
      </tab-content>

      <!-- tab 2 content -->
      <tab-content v-if="toggleOn" title="Add Gift Card" class="mb-5">
        <!-- <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <vs-input
              label="Proposal Title"
              v-model="proposalTitle"
              class="w-full mt-4"
            />
            <vs-input
              label="Job Title"
              v-model="jobTitle"
              class="w-full mt-4"
            />
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <vs-textarea
              v-model="textarea"
              label="Short discription"
              class="mb-0 md:mt-10 mt-6"
              rows="3"
            />
          </div>
        </div> -->
        <vx-card>
          <div slot="no-body" class="full-page-bg-color">
            <div class="vx-row no-gutter items-center">
              <div class="vx-col sm:w-full md:w-full d-theme-dark-bg">
                <div class="p-8 login-tabs-container">
                  <div class="vx-card__title mb-4">
                    <h4 class="mb-4 text-primary">Create Gift Card</h4>
                    <p>
                      Start creating your giftcard now. Please note that
                      validity for each gift card that you have created will be
                      6 months from purchase date.
                    </p>
                    <div class="vx-row">
                      <div class="vx-col md:w-1/2 w-full mt-5">
                        <vs-input
                          type="text"
                          name="giftcardFaceVal"
                          label="Gift Card Name"
                          v-model="giftcardName"
                          class="w-full mt-6"
                        />
                      </div>
                      <div class="vx-col md:w-1/4 w-full mt-5">
                        <div class="flex items-end">
                          <vs-input
                            type="text"
                            name="giftcardSellingPrice"
                            label="Selling Price"
                            v-model="giftcardSellingPrice"
                            class="w-full mt-6"
                          />
                          <vx-tooltip
                            text="Selling Price - Gift Card Selling Price to customers at our platform."
                            position="top"
                            class="mb-10"
                          >
                            <feather-icon
                              icon="HelpCircleIcon"
                              svgClasses="w-5 h-5 hover:text-primary stroke-current text-primary"
                            />
                          </vx-tooltip>
                          <!-- <span class="font-medium text-lg leading-none"
                            >Permissions</span -->
                        </div>
                        <!-- <vs-input
                          type="text"
                          name="giftcardSellingPrice"
                          label="Selling Price"
                          v-model="giftcardSellingPrice"
                          class="w-full mt-6"
                        />
                        <vx-tooltip text="lorem ipsor bla bla" position="right">
                          <feather-icon
                            icon="HelpCircleIcon"
                            svgClasses="w-5 h-5 hover:text-primary stroke-current text-dark"
                          />
                        </vx-tooltip> -->
                      </div>
                      <div class="vx-col md:w-1/4 w-full mt-5">
                        <div class="flex items-end">
                          <vs-input
                            type="text"
                            name="giftcardFaceVal"
                            label="Face Value"
                            v-model="giftcardFaceVal"
                            class="w-full mt-6"
                          />
                          <vx-tooltip
                            text="Face Value - Actual Credit received by customers upon purchased of Gift Card."
                            position="top"
                            class="mb-10"
                          >
                            <feather-icon
                              icon="HelpCircleIcon"
                              svgClasses="w-5 h-5 hover:text-primary stroke-current text-primary"
                            />
                          </vx-tooltip>
                        </div>
                      </div>
                    </div>
                    <div class="vx-row">
                      <div class="vx-col w-full mt-5">
                        <label for="giftcardDesc">Gift Card Description</label>
                        <vs-textarea
                          type="text"
                          name="giftcardDesc"
                          v-model="giftcardDesc"
                          class="w-full mt-0"
                          height="130px"
                          width="200px"
                        />
                      </div>
                    </div>
                    <div class="vx-row">
                      <div class="vx-col w-full mt-0">
                        <div class="flex items-end">
                          <label for="giftcardTnc">Terms and Conditions</label>
                          <div class="ml-2">
                            <vx-tooltip :customText="true" position="top">
                              <feather-icon
                                icon="HelpCircleIcon"
                                svgClasses="w-5 h-5 hover:text-primary stroke-current text-primary"
                              />
                            </vx-tooltip>
                          </div>
                        </div>
                        <vs-textarea
                          name="giftcardTnc"
                          v-model="giftcardTnc"
                          class="w-full mt-0"
                          height="130px"
                          width="200px"
                        />
                      </div>
                    </div>

                    <div class="vx-row">
                      <div class="vx-col w-full mt-5">
                        <!-- <di class="vx-col md:w-1/2 upload-img mt-6"> -->
                        <div
                          class="vx-card"
                          style="border: dashed 2px lightgrey;"
                        >
                          <div class=" my-4 ml-3">
                            <div class="flex justify-start">
                              <img
                                src="@/assets/images/image.png"
                                style="display: block; width:auto!important; height: 70px!important;"
                              />
                              <div class="flex flex-col ml-6" vs-w="3.5">
                                <h3 class="text-gray">
                                  Upload Gift Card Image
                                </h3>
                                <vs-col vs-w="8">
                                  <h5 class="text-grey">
                                    Please make sure that your image ratio is
                                    16:9 with minimum width of 480px
                                  </h5>
                                </vs-col>
                              </div>
                              <div class="text-right mr-6 mt-5">
                                <!-- <vs-col vs-offset="24"> -->
                                <!-- <div> -->
                                <vs-button @click="$refs.uploadImgInput.click()"
                                  >Upload Image</vs-button
                                >
                                <!-- </vs-col> -->
                              </div>
                              <!-- </div> -->
                            </div>
                          </div>
                          <div class="mb-3 ml-3">
                            <div
                              class="img-container flex items-center "
                              style="position: relative"
                            >
                              <img
                                v-if="giftcardImg"
                                :src="giftcardImg"
                                alt="img"
                                width="480px"
                                height="270px"
                              />
                            </div>
                          </div>
                        </div>
                        <input
                          type="file"
                          class="hidden"
                          ref="uploadImgInput"
                          accept="image/*"
                          @change="uploadImg($event)"
                        />
                      </div>
                    </div>
                    <div class="vx-row">
                      <div class="vx-col md:w-1/2 w-full mt-5">
                        <label for="validFromDate">Listing Date From</label>
                        <datepicker
                          type="text"
                          name="validFromDate"
                          v-model="validFromDate"
                          clear-button-icon
                          class="w-full mt-0"
                        >
                        </datepicker>
                      </div>
                      <div class="vx-col md:w-1/2 w-full mt-5">
                        <label for="validToDate">Listing Date To</label>
                        <datepicker
                          type="text"
                          name="validToDate"
                          v-model="validToDate"
                          class="w-full mt-0"
                        >
                        </datepicker>
                      </div>
                    </div>
                    <div class="vx-row">
                      <div class="vx-col md:w-1/2 w-full md:mt-2">
                        <div class="demo-alignment">
                          <vs-checkbox v-model="whiteKnightPrivileged"
                            >#WhiteKnight privileged</vs-checkbox
                          >
                          <vx-tooltip
                            text="#WhiteKnight Privileged - During purchase of E-Gift Card from this period, the customer will receive a #WhiteKnight status, so in the future they can continue to enjoy special privileges from your business."
                            position="top"
                          >
                            <feather-icon
                              icon="HelpCircleIcon"
                              svgClasses="w-5 h-5 hover:text-primary stroke-current text-primary"
                            />
                          </vx-tooltip>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 mt-5">
                        <vs-input-number
                          type="text"
                          name="privilegeMaxRedeemCount"
                          label="Privilege Max Redeem Count:"
                          v-model="privilegeMaxRedeemCount"
                          :disabled="whiteKnightPrivileged ? false : true"
                          class="w-full mt-2"
                        />
                      </div>
                      <div class="vx-col w-full mt-3">
                        <label for="privilegeDesc">Privilege Description</label>
                        <vs-textarea
                          type="text"
                          name="privilegeDesc"
                          v-model="privilegeDesc"
                          :disabled="whiteKnightPrivileged ? false : true"
                          class="w-full mt-0"
                          height="130px"
                          width="200px"
                        />
                      </div>
                    </div>
                    <br />
                    <vs-row vs-justify="center">
                      <vs-button
                        class="centerx"
                        :disabled="!validateForm"
                        @click="addGiftCard"
                        >ADD GIFT CARD</vs-button
                      >
                    </vs-row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
        <br />
        <vs-table :data="giftcardsComputed" v-if="giftcardsComputed.length > 0">
          <template slot="thead">
            <vs-th></vs-th>
            <vs-th>
              Name
            </vs-th>
            <vs-th>
              Description
            </vs-th>
            <vs-th>
              Selling Price
            </vs-th>
            <vs-th>
              Face Value
            </vs-th>
            <vs-th>
              TnC
            </vs-th>
            <vs-th>
              Valid from
            </vs-th>
            <vs-th>
              Valid to
            </vs-th>
            <vs-th> </vs-th>
          </template>

          <!-- <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in giftcardsComputed">
              <vs-td :data="tr.giftcardImage">
                <div
                  class="img-container w-32 mx-auto flex items-center justify-center"
                >
                  <img :src="tr.giftcardImg" alt="img" class="responsive" />
                </div>
              </vs-td>

              <vs-td :data="tr.giftcardName">
                {{ tr.giftcardName }}
              </vs-td>

              <vs-td :data="tr.giftcardDesc">
                {{ tr.giftcardDesc }}
              </vs-td>

              <vs-td :data="tr.giftcardSellingPrice">
                {{ tr.giftcardSellingPrice }}
              </vs-td>

              <vs-td :data="tr.giftcardFaceVal">
                {{ tr.giftcardFaceVal }}
              </vs-td>

              <vs-td :data="tr.giftcardTnc">
                {{ tr.giftcardTnc }}
              </vs-td>

              <vs-td :data="tr.validFromDate">
                <div>
                  {{
                    dateTimeFormatter(new Date(Date.parse(tr.validFromDate)))[0]
                  }}
                </div>
                <div>
                  {{
                    dateTimeFormatter(new Date(Date.parse(tr.validFromDate)))[1]
                  }}
                </div>
              </vs-td>

              <vs-td :data="tr.validToDate">
                <div>
                  {{
                    dateTimeFormatter(new Date(Date.parse(tr.validToDate)))[0]
                  }}
                </div>
                <div>
                  {{
                    dateTimeFormatter(new Date(Date.parse(tr.validToDate)))[1]
                  }}
                </div>
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  @click.stop="editGiftcard(tr)"
                />
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click="openConfirm(tr)"
                />
              </vs-td>
            </vs-tr>
          </template> -->
        </vs-table>
      </tab-content>
      <!-- tab 3 content -->
      <!-- <tab-content title="Step 3" class="mb-5">
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <vs-input
              label="Event Name"
              v-model="eventName"
              class="w-full mt-5"
            />
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <vs-select
              v-model="city"
              class="w-full select-large mt-5"
              label="Event Location"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in cityOptions"
                class="w-full"
              />
            </vs-select>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5">
            <vs-select
              v-model="status"
              class="w-full select-large"
              label="Event Status"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in statusOptions"
                class="w-full"
              />
            </vs-select>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mt-8">
            <div class="demo-alignment">
              <span>Requirements:</span>
              <div class="flex">
                <vs-checkbox>Staffing</vs-checkbox>
                <vs-checkbox>Catering</vs-checkbox>
              </div>
            </div>
          </div>
        </div>
      </tab-content> -->
    </form-wizard>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { FormWizard, TabContent, WizardButton, WizardStep } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { Validator } from "vee-validate";
import giftcardSidebar from "./pages/giftcardSidebar";
import mixin from "../mixin";
import axios from "../axios";
import vSelect from 'vue-select'

const dict = {
  custom: {
    companyName: {
      required: "Company name is required"
    },
    companyROCNo: {
      required: "Company ROC No is required"
    },
    brandName: {
      required: "Brand name is required"
    },
    ownerName: {
      required: "Owner name is required"
    },
    ownerContactNo: {
      required: "Owner Contact No. is required",
      regex: "The phone number format is invalid"
    },
    picName: {
      required: "PIC name is required"
    },
    picDesignation: {
      required: "PIC Designation is required"
    },
    picContactNo: {
      required: "PIC Contact No. is required",
      regex: "The phone number format is invalid"
    },
    picEmail: {
      required: "PIC Email is required",
      email: "PIC Email is not valid"
    },
    picEmailConfirm: {
      required: "Confirm PIC Email is required",
      email: "PIC Email is not valid",
    },
    bankName: {
      required: "Bank name is required"
    },
    accountName: {
      required: "Account name is required"
    },
    accountNo: {
      required: "Account No is required",
      numeric: "Account No must contain numbers only"
    },
    address1: {
      required: "Address 1 is required"
    },
    postcode: {
      required: "Postcode is required",
      regex: "Postcode must be contain 5 digits only"
    },
    state: {
      required: "State is required"
    },
    acceptTnc: {
      custom_validation: "You must accept the terms and conditions to proceed."
    },
    acceptPackages: {
      custom_validation1: "You must choose a package."
    }
  }
};
Validator.localize("en", dict);
export default {
  components: {
    Datepicker,
    FormWizard,
    TabContent,
    WizardButton,
    WizardStep,
    giftcardSidebar,
    vSelect
  },
  data() {
    return {
      packages: [
        { id: 1, name: "Package I - MiniPOS", isSelected: false },
        { id: 2, name: "Package II - Online Store for Restaurant", isSelected: false },
        { id: 3, name: "Package III - Invited Marketplace", isSelected: false }
      ],
      toggleOn: false,
      companyName: "",
      companyROCNo: "",
      brandName: "",
      brandDesc: "",
      ownerName: "",
      ownerContactNo: "",
      ownerEmail: "",
      picName: "",
      picContactNo: "",
      picDesignation: "",
      picEmail: "",
      picEmailConfirm: "",
      address1: "",
      address2: "",
      address3: "",
      address4: "",
      postcode: "",
      state: "",
      bankName: "",
      accountName: "",
      accountNo: "",
      package1: false,
      package2: false,
      package3: false,
      mcSalesManUid:"",

      giftcards: this.$store.state.giftcard.giftcards,
      giftcardName: "",
      giftcardImg: "",
      giftcardImgName: "",
      giftcardFaceVal: "",
      giftcardSellingPrice: "",
      giftcardDesc: "",
      giftcardTnc: "",
      validFromDate: "",
      validToDate: "",
      whiteKnightPrivileged: false,
      privilegeMaxRedeemCount: 0,
      privilegeDesc: "",
      sidebarData: {},
      addNewDataSidebar: false,
      tncPopUp: false,
      acceptTnc: false,
      tncMsg: `Terms and Condition - Merchant should set out their own definition of the terms and conditions (T&C) apply to e-Gift Card for the Buyer to abide to, before the Buyer accepting the e-Gift Card. Below is the typical T&C used for the e-Gift Card:
(1) This Gift Card is only used for the payment made in Malaysian Ringgit. Any currency to purchase the goods or services other than Malaysian Ringgit is not applicable to this Gift Card.
(2) This Gift Card is not redeemable for or in exchange with cash under any circumstances.
(3) This Gift Card is valid for 12 months from the date of purchase.
(4) The terms and conditions as stated in this Gift Card shall be subject to amendment as any time and at the sole discretion of Merchant Company without prior notice. Any amendment thereof shall be published and shall be thereupon binding on the customer.
(5) Merchant Company shall not assume any responsibility or liability for lost, damaged, stolen or any unauthorized use of these cards.
(6) Any money for topping-up in this Gift Card shall not be transferable to another Gift Card unless otherwise authorised by Merchant Company.
(7) This Gift Card must be presented to the counter before any refund transaction can be made.
*Note: The term and condition must be checked by staff during redemption of gift card.`
    };
  },
  methods: {
    checkTnc() {
      if (this.acceptTnc) {
        this.errors.remove("acceptTnc", "step-1");
      } else {
        this.errors.add({
          scope: "step-1",
          field: "acceptTnc",
          msg: "You must accept the terms and conditions to proceed."
        });
      }
    },
    checkPackages() {
      console.log("checkPackages");

      if (this.packages[0].isSelected || this.packages[1].isSelected || this.packages[2].isSelected) {
        this.errors.remove("acceptPackages", "step-1");
      } else {
        this.errors.add({
          scope: "step-1",
          field: "acceptPackages",
          msg: "You must select a package."
        });
      }
    },
    checkCustomConfirm() {
      if(this.picEmailConfirm != "" && this.picEmailConfirm.toLowerCase() == this.picEmail.toLowerCase()){
       this.errors.remove("picEmailConfirm", "step-1"); 
      }
      else if (this.picEmailConfirm == ""){
        this.errors.remove("picEmailConfirm", "step-1"); 
        this.errors.add({
          scope: "step-1",
          field: "picEmailConfirm",
          msg: "Please confirm your email"
        });
      }
      else if (this.picEmailConfirm != this.picEmail){
        this.errors.remove("picEmailConfirm", "step-1"); 
        this.errors.add({
          scope: "step-1",
          field: "picEmailConfirm",
          msg: "PIC Emails do not match"
        });
      }
    },
    uploadImg(input) {
      console.log(input);
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader();
        reader.onload = e => {
          /* this.$store.commit(
            "giftcard/SET_GIFTCARD_IMAGE",
            e.target.result,
            giftcardId
      ) */
          console.log(e.target.result);
          this.giftcardImg = e.target.result;
        };
        this.giftcardImgName = input.target.files[0].name;

        reader.readAsDataURL(input.target.files[0]);
      }
    },
    addGiftCard() {
      let newGiftCard = {
        giftcardName: this.giftcardName,
        giftcardDesc: this.giftcardDesc,
        giftcardSellingPrice: parseInt(this.giftcardSellingPrice),
        giftcardFaceVal: parseInt(this.giftcardFaceVal),
        giftcardTnc: this.giftcardTnc,
        giftcardImg: this.giftcardImg,
        giftcardImgName: this.giftcardImgName,
        validFromDate: this.validFromDateComputed,
        validToDate: this.validToDateComputed,
        whiteKnightPrivileged: this.whiteKnightPrivileged ? "y" : "n",
        privilegeMaxRedeemCount: this.privilegeMaxRedeemCountComputed,
        privilegeDesc: this.privilegeDesc
      };
      this.$store.commit("giftcard/ADD_GIFTCARD", newGiftCard);
      this.initForm();
    },
    deleteGiftcard(giftcard) {
      this.$store.commit("giftcard/DELETE_GIFTCARD", giftcard);
    },
    editGiftcard(data) {
      this.sidebarData = data;
      this.toggleSidebar(true);
    },
    openConfirm(giftcard) {
      this.$vs.dialog({
        acceptText: "Confirm",
        type: "confirm",
        color: "danger",
        title: `Delete Giftcard`,
        text: `Are you sure you would like to delete ${giftcard.giftcardName}?`,
        accept: this.acceptAlert,
        parameters: giftcard
      });
    },
    acceptAlert(giftcard) {
      this.deleteGiftcard(giftcard);
      this.$vs.notify({
        color: "danger",
        title: "Deleted image",
        text: `${giftcard.giftcardName} was successfully deleted.`
      });
    },
    toggleSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    initForm() {
      this.giftcardName = "";
      this.giftcardFaceVal = 0;
      this.giftcardSellingPrice = 0;
      this.giftcardDesc = "";
      this.giftcardImg = "";
      this.validFromDate = "";
      this.validToDate = "";
      this.giftcardTnc = "";
      this.whiteKnightPrivileged = false;
      this.privilegeMaxRedeemCount = 1;
      this.privilegeDesc = "";
    },
    modifyState(input) {
      console.log(input.target.value);
    },
    async formSubmitted() {
      if(confirm('Submit?')){}else{return;}
      console.log('formsSubmitted');
      var bankname = "";
      if(this.bankName == undefined || this.bankName == null || this.bankName == ""){
        bankname = "";
      }else{
        bankname = this.bankName.value;
      }
      // let result = await this.validateStep1();
      // console.log('validateStep 1 result: ' + result);
      this.validateStep1().then(async (res) => {
        console.log(res);
        this.$vs.loading();
      let merchantDetails = {
        companyName: this.companyName,
        brandName: this.brandName,
        companyROCNo:this.companyROCNo,
        mcSalesManUid: this.mcSalesManUid,
        brandDesc: this.brandDesc,
        ownerName: this.ownerName,
        ownerContactNo: this.ownerContactNo,
        picName: this.picName,
        picContactNo: this.picContactNo,
        picDesignation: this.picDesignation,
        picEmail: this.picEmail,
        bankName: bankname,
        accountNo: this.accountNo,
        accountName: this.accountName,
        address1: this.address1,
        address2: this.address2,
        address3: this.address3,
        address4: this.address4,
        postcode: this.postcode,
        state: this.state.value,
        packages: this.packages
      };
      this.$store.commit("giftcard/SAVE_MERCHANT", merchantDetails);
      let payload = {
        mcName: this.companyName,
        mcRegNo: this.companyROCNo,
        mcOwnerName: this.ownerName,
        mcOwnerTelNo: this.ownerContactNo,
        mcSalesManUid: this.mcSalesManUid,
        mcEmail: this.ownerEmail,
        mcContactperson: this.picName,
        mcContactpersonTelno: this.picContactNo,
        mcDesignation: this.picDesignation,
        mcContactpersonEmail: this.picEmail,
        mcBrandDescription: this.brandDesc,
        mcAddress1: this.address1,
        mcAddress2: this.address2,
        mcAddress3: this.address3,
        mcAddress4: this.address4,
        mcPostcode: this.postcode,
        mcState: this.state.value,
        mcCountry: "my",
        mcBrandName: this.brandName,
        mcBankName: bankname,
        mcBancAccName: this.accountName,
        mcBankNumber: this.accountNo,
        merchantPackage: [
          { name: this.packages[0].id, selected: this.packages[0].isSelected },
          { name: this.packages[1].id, selected: this.packages[1].isSelected},
          { name: this.packages[2].id, selected: this.packages[2].isSelected}
        ],
        giftcardMasters: []
      };
      for (let i = 0; i < this.$store.state.giftcard.giftcards.length; i++) {
        let giftcardImgUrl;
        let splitImageUrl = this.$store.state.giftcard.giftcards[
          i
        ].giftcardImg.split(",");
        let imagebyte = splitImageUrl[1];

        let giftcardImgPayload = {
          imageByte: imagebyte,
          fileName: this.$store.state.giftcard.giftcards[i].giftcardImgName
        };
        console.log(giftcardImgPayload);

        const headers = {
          headers: {
            "Content-Type": "application/json",
            ApiKey: "1qazXSW@"
          }
        };
        try {
          let response = await axios.post(
            "api/imageupload",
            giftcardImgPayload,
            headers
          );
          giftcardImgUrl = response["data"];
          console.log(giftcardImgUrl);
        } catch (e) {
          console.log(e);
        }
        let giftcard = {
          gaName: this.$store.state.giftcard.giftcards[i].giftcardName,
          gaSellingPrice: this.$store.state.giftcard.giftcards[i]
            .giftcardSellingPrice,
          gaSellingValue: this.$store.state.giftcard.giftcards[i]
            .giftcardFaceVal,
          gaTnc: this.$store.state.giftcard.giftcards[i].giftcardTnc,
          gaImg: giftcardImgUrl,
          gaDescription: this.$store.state.giftcard.giftcards[i].giftcardDesc,
          gaStarteffectivedate: this.$store.state.giftcard.giftcards[i]
            .validFromDate,
          gaEndeffectivedate: this.$store.state.giftcard.giftcards[i]
            .validToDate,
          whiteKnightPrivileged: this.$store.state.giftcard.giftcards[i]
            .whiteKnightPrivileged,
          privilegeMaxRedeemCount: this.$store.state.giftcard.giftcards[i]
            .privilegeMaxRedeemCount,
          privilegeDesc: this.$store.state.giftcard.giftcards[i].privilegeDesc
        };
        payload.giftcardMasters.push(giftcard);
      }
      console.log(payload);
      console.log(JSON.stringify(payload));
      await this.$store.dispatch("giftcard/registerMerchant", payload);
      this.$vs.loading.close();
      this.redirectToRoute("/registersuccess");
      console.log("submitted");
        }).catch((err)=>console.log(err));
    },
    
    validateStep1() {
      return new Promise((resolve, reject) => {
        this.checkTnc();

        /* if (!this.acceptTnc) {
          this.errors.add({
            scope: "step-1",
            field: "acceptTnc",
            msg: "You must accept the terms and conditions to proceed."
          });
        }
          if (!this.packages[0].isSelected && !this.packages[1].isSelected && !this.packages[2].isSelected) {
          console.log(
            "package1: " +
              this.package1 +
              "package2: " +
              this.package2 +
              "package3: " +
              this.package3
          );

          this.errors.add({
            scope: "step-1",
            field: "acceptPackages",
            msg: "You must choose a package."
          });
        } */
        /* if (!this.matchEmail) {
          console.log('!this.matchEmail');
          
          this.errors.add({
            scope: "step-1",
            field: "picEmailConfirm",
            msg: "PIC Emails do not match"
          });
        } */
        this.checkPackages();
        this.checkCustomConfirm();
        this.$validator.validateAll("step-1").then(result => {
          if (result) {
            console.log("true");

            // return true;
            resolve(true);
          } else {
            console.log("false");
            reject(false);
            // return false;
          }
        });
      });
    }
  },
  mixins: [mixin],
  created () {
    this.$validator.extend('custom_validation', (value) => {
    return value === true
});
this.$validator.extend('custom_validation1', (value) => {
    return (this.packages[0].isSelected || this.packages[1].isSelected || this.packages[2].isSelected)
});
this.$validator.extend('custom_validation2', (value) => {
    return (this.picEmailConfirm.toLowerCase() == this.picEmail.toLowerCase())
});
    /* this.$validator.attach('acceptTnc', 'required|custom_validation', {
      getter: () => this.acceptTnc
      }); */
  },
  mounted(){
     this.mcSalesManUid = this.$route.query.s;
        if(this.mcSalesManUid == undefined){
          this.mcSalesManUid = "";
        }
  },
  computed: {
    matchEmail() {
      return this.picEmailConfirm === this.picEmail;
    },
    privilegeMaxRedeemCountComputed() {
      return this.whiteKnightPrivileged ? this.privilegeMaxRedeemCount : 0;
    },
    validateForm() {
      return (
        this.validFromDate &&
        this.validToDate &&
        this.giftcardImg &&
        this.validToDate > this.validFromDate
      );
    },
    validFromDateComputed() {
      return this.validFromDate ? this.validFromDate.toISOString() : "";
    },
    validToDateComputed() {
      return this.validToDate ? this.validToDate.toISOString() : "";
    },
    giftcardsComputed() {
      return this.$store.state.giftcard.giftcards;
    },
    states() {
      return this.statesList;
    },
    banks() {
      return this.bankList;
    },
    
  },
  
  watch: {
    whiteKnightPrivileged() {
      if (!this.whiteKnightPrivileged) {
        this.privilegeMaxRedeemCount = 0;
      } else {
        this.privilegeMaxRedeemCount = 1;
      }
    }
  },
  
};
</script>
<style scoped>
.required {
  color: red;
}
</style>
